function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "j\xF6 Logo");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M45.66,44.4a6.73,6.73,0,0,1-5.26-2.77,4.71,4.71,0,0,0,0,.53,5.29,5.29,0,0,0,10.58,0c0-.18,0-.35,0-.53A6.73,6.73,0,0,1,45.66,44.4Z",
  transform: "translate(0 0)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M71.17,56.55a38,38,0,1,0-14.6,14.6L76,76ZM51.43,17.24A4.9,4.9,0,0,1,56.14,22a4.71,4.71,0,0,1-9.42,0A4.9,4.9,0,0,1,51.43,17.24Zm-11.54,0A4.9,4.9,0,0,1,44.6,22a4.71,4.71,0,0,1-9.42,0A4.9,4.9,0,0,1,39.89,17.24Zm-9.7,33.21c0,6.28-4,10.32-9.42,10.32a14.74,14.74,0,0,1-4.93-.9l.89-7.63a9.15,9.15,0,0,0,2.25.45,2.12,2.12,0,0,0,2.24-2.24V29.36h9ZM25.71,26.67A4.9,4.9,0,0,1,21,22a4.9,4.9,0,0,1,4.71-4.72A4.9,4.9,0,0,1,30.42,22,4.9,4.9,0,0,1,25.71,26.67ZM45.66,53.14A12.34,12.34,0,1,1,58,40.8,12.34,12.34,0,0,1,45.66,53.14Z",
  transform: "translate(0 0)"
});

var SvgAssetsLogo = function SvgAssetsLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 76 76.01",
    width: 20,
    height: 20,
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAssetsLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/assets-logo.d35eb052.svg";
export { ForwardRef as ReactComponent };